import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 group">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-fill text-2xl text-primary-500"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-900 whitespace-nowrap">
                亚洲精品视频
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              <Link
                to="/"
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === '/'
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                首页
              </Link>
              <Link
                to="/category/dianying"
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname.startsWith('/category')
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                分类浏览
              </Link>
              <Link
                to="/about"
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === '/about'
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                关于我们
              </Link>
            </div>

            <div className="hidden md:flex items-center gap-3">
              <button className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                登录
              </button>
              <button className="px-5 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                免费注册
              </button>
            </div>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {mobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-foreground-950/40" onClick={() => setMobileOpen(false)}></div>
          <div className="absolute top-16 left-0 right-0 bg-background-50 border-b border-background-200/70 py-4 px-4">
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-md transition-colors"
              >
                首页
              </Link>
              <Link
                to="/category/dianying"
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-md transition-colors"
              >
                分类浏览
              </Link>
              <Link
                to="/about"
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-md transition-colors"
              >
                关于我们
              </Link>
              <div className="border-t border-background-200/70 mt-2 pt-3 flex gap-2">
                <button className="flex-1 px-4 py-2.5 text-sm font-medium text-foreground-700 border border-background-300 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
                  登录
                </button>
                <button className="flex-1 px-4 py-2.5 text-sm font-medium bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  免费注册
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}